<script setup>
import { reactive, computed, watch, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();
const { $bus, $constants, $stores } = proxy;

const sourceData = computed(() => $stores.appData?.state?.data?.general || {});

const form = reactive({
  whatsappLink: '',
  facebookLink: '',
  instagramLink: '',
  telegramLink: '',
  tiktokLink: '',
  websiteLink: '',
  policyUrl: '',
  cguUrl: '',
  faqUrl: ''
});

watch(
  sourceData,
  (data) => {
    if (!data) return;
    Object.assign(form, {
      whatsappLink: data.whatsappLink || '',
      facebookLink: data.facebookLink || '',
      instagramLink: data.instagramLink || '',
      telegramLink: data.telegramLink || '',
      tiktokLink: data.tiktokLink || '',
      websiteLink: data.websiteLink || '',
      policyUrl: data.policyUrl || '',
      cguUrl: data.cguUrl || '',
      faqUrl: data.faqUrl || ''
    });
  },
  { immediate: true }
);

const hasChanges = computed(() =>
  Object.keys(form).some((key) => form[key] !== sourceData.value?.[key])
);

function save() {
  if (!hasChanges.value) return;

  const payload = { general: {} };

  Object.keys(form).forEach((key) => {
    if (form[key] !== sourceData.value?.[key]) {
      payload.general[key] = form[key];
    }
  });

  $bus.emit($constants.EVENTS.APP_DATA.UPDATE_GENERAL, payload);
}

function resetAll() {
  Object.assign(form, sourceData.value || {});
}
</script>

<template>
  <div class="space-y-6">
    <!-- HEADER -->
    <div class="flex justify-between items-center">
      <h2 class="text-xl font-semibold">Liens sociaux et légaux</h2>
      <div class="flex gap-3" v-show="hasChanges">
        <button
          class="px-6 py-2 rounded-xl bg-gray-300 text-gray-700"
          @click="resetAll"
        >
          Annuler
        </button>
        <button
          class="px-6 py-2 rounded-xl bg-primary-600 text-white"
          @click="save"
        >
          Sauvegarder
        </button>
      </div>
    </div>

    <!-- FIELDS -->
    <div class="bg-slate-100 rounded-3xl p-6">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div>
          <label class="block mb-1 text-sm font-medium">WhatsApp</label>
          <input class="inputComponent" v-model="form.whatsappLink" />
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium">Facebook</label>
          <input class="inputComponent" v-model="form.facebookLink" />
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium">Instagram</label>
          <input class="inputComponent" v-model="form.instagramLink" />
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium">Telegram</label>
          <input class="inputComponent" v-model="form.telegramLink" />
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium">TikTok</label>
          <input class="inputComponent" v-model="form.tiktokLink" />
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium">Site Web</label>
          <input class="inputComponent" v-model="form.websiteLink" />
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium"
            >Politique de confidentialité</label
          >
          <input class="inputComponent" v-model="form.policyUrl" />
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium"
            >Conditions Générales</label
          >
          <input class="inputComponent" v-model="form.cguUrl" />
        </div>

        <div>
          <label class="block mb-1 text-sm font-medium">FAQ</label>
          <input class="inputComponent" v-model="form.faqUrl" />
        </div>
      </div>
    </div>
  </div>
</template>
